/**
 * Root, debug overlay, dialog and prompt.
 *
 * One slice of the base-view stylesheet. `styles/index.ts` concatenates
 * every slice into the single sheet `injectStyles` mounts — the split is
 * about OWNERSHIP, not about emitting more than one style element.
 *
 * NO BACKTICKS anywhere in this file, comments included: the export below
 * is one template literal and a stray backtick terminates it. That has
 * broken the build twice, both times with esbuild pointing at a line ten
 * rows away from the cause. Write class names in plain text.
 */
export default `
.bv-root { position: relative; width: 100%; height: 100%; overflow: hidden; background: var(--ground); }
.bv-root canvas { display: block; cursor: grab; }
.bv-root canvas.bv-hover-interactable { cursor: pointer; }
.bv-root canvas:active { cursor: grabbing; }

/* Bottom-left, standing on the action dock: the dock took the corner itself
   on 2026-10-16 ("where debug is now"), so the panel moved up by the height
   the dock publishes (--bv-ab-dock-h, ui/action-bar.ts). Dev builds only. */
.bv-debug {
  position: absolute; bottom: calc(20px + var(--bv-ab-dock-h, 0px)); left: 12px; z-index: 5;
  font: 12px/1.6 var(--font-technical);
  color: var(--bone); background: rgba(15,9,5,0.82);
  border: 1px solid var(--line); border-radius: var(--radius-well);
  padding: 8px 12px; letter-spacing: 0.02em;
  box-shadow: inset 0 0 0 1px rgba(210,164,86,0.1), 0 6px 18px rgba(0,0,0,0.4);
  pointer-events: none; font-variant-numeric: tabular-nums;
  text-shadow: 0 1px 2px rgba(0,0,0,0.6);
  backdrop-filter: blur(2px);
}
.bv-debug-k { color: var(--brass-bright); display: inline-block; width: 42px; text-transform: uppercase; font-size: 10px; }
.bv-debug-toggle {
  pointer-events: auto; margin-top: 8px; width: 100%;
  font: 700 12px/1.6 var(--font-display); letter-spacing: 0.08em;
  color: var(--bone); background: rgba(122,90,48,0.35);
  border: 1px solid var(--line); border-radius: var(--radius-tape);
  padding: 4px 8px; cursor: pointer; text-transform: uppercase;
}
.bv-debug-toggle:hover { background: rgba(122,90,48,0.55); }
.bv-debug-toggle-on {
  color: #14100b; background: var(--brass-hot); border-color: var(--brass-hot);
  box-shadow: 0 0 8px rgba(255,179,92,0.6);
}
.bv-debug-toggle-on:hover { background: #ffc37a; }

.bv-prompt {
  position: absolute; left: 50%; bottom: 26px; transform: translateX(-50%); z-index: 6;
  font: 12px var(--font-technical); color: var(--bone); letter-spacing: 0.12em;
  background: rgba(20,12,7,0.8); border: 1px solid var(--line);
  border-radius: 20px; padding: 7px 16px; text-transform: uppercase; pointer-events: none;
}
.bv-prompt[hidden] { display: none; }
/* On a narrow screen the centred prompt reaches into the bottom-left action
   dock, so it stands on top of it instead. */
@media (max-width: 720px) {
  .bv-prompt { bottom: calc(20px + var(--bv-ab-dock-h, 0px)); }
}
.bv-prompt b { color: var(--brass-hot); }
`;
